export default "__VITE_ASSET__bb41c378__"